/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity level`)
};

const es_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de actividad`)
};

const de_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitätsniveau`)
};

const nl_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteitsniveau`)
};

const fr_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau d'activité`)
};

const it_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello di attività`)
};

const pt_br2_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de atividade`)
};

const pt_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de atividade`)
};

const ja_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動レベル`)
};

const zh_bmr_activity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动水平`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_activity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_activity(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_activity", locale)
	if (locale === "en") return en_bmr_activity(inputs)
	if (locale === "es") return es_bmr_activity(inputs)
	if (locale === "de") return de_bmr_activity(inputs)
	if (locale === "nl") return nl_bmr_activity(inputs)
	if (locale === "fr") return fr_bmr_activity(inputs)
	if (locale === "it") return it_bmr_activity(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_activity(inputs)
	if (locale === "pt") return pt_bmr_activity(inputs)
	if (locale === "ja") return ja_bmr_activity(inputs)
	return zh_bmr_activity(inputs)
};